import React from 'react';
import PropTypes from 'prop-types';
import { View, Row, Col } from '../View';
import { MenuCheck } from "../../../assets/icons"
import { styleUtils } from '../../utils';
import styles from './styles';
import Text from "../Text";

const { style } = styleUtils;
const RootContainer = style(View, styles.rootContainer);
const RowContainer = style(Row, styles.rowContainer);
const StepItem = style(Col, styles.item);
const StepIcon = style(View, styles.icon);
const StepLabel = style(Text, styles.label);

const iconProps = {
  width: 14,
  height: 11,
  fill: '#17A2B8'
};

const getStep = (step, items, history = {}) => {
  const {location = {}} = history;
  const { pathname } = location;

  if(!pathname) {
    return items[step].step;
  }

  const currentStep =  items.filter((item, i) => item.to === pathname);
  return currentStep[0] ? currentStep[0].step : items[items.length - 1].step;
};

const handleOnclick = ({item, enableClick}, history) => {
  if(enableClick) {
    history.push(item.to);
  }
};

const WizardSteps = ({items, step, history}) => (
  <RootContainer>
    <RowContainer type="flex" justify="space-between">
      {
        items.map( (item, i) => {
          const currentStep = getStep(step, items, history) - 1;
          const checkedStyle = i < currentStep ? 'checked ' : '';
          const activeStyle = i === currentStep ? 'active ' : '';
          const disabledStyle = i > currentStep ? 'disabled ' : '';
          const enableClick = i < currentStep;

          return (
            <StepItem
              key={item.step}
              className={`${checkedStyle}${activeStyle}${disabledStyle}`}
              onClick={() => handleOnclick({item, enableClick}, history)}
            >
              <StepIcon data-checked="true" className="icon">
                <MenuCheck {...iconProps} />
              </StepIcon>
              <StepLabel>{item.label}</StepLabel>
            </StepItem>
          )
        })
      }
    </RowContainer>
  </RootContainer>
);

WizardSteps.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    to: PropTypes.string,
    step: PropTypes.number
  }))
};

WizardSteps.defaultProps = {
  items: [],
  step: 1
};

export default WizardSteps;
